import { render, staticRenderFns } from "./EventListEditor.vue?vue&type=template&id=c4c45b1c&scoped=true&"
import script from "./EventListEditor.vue?vue&type=script&lang=ts&"
export * from "./EventListEditor.vue?vue&type=script&lang=ts&"
import style0 from "./EventListEditor.vue?vue&type=style&index=0&id=c4c45b1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c45b1c",
  null
  
)

export default component.exports